import React, {useState} from "react";
import GoogleIcon from "@mui/icons-material/Google";
import IconButton from "@mui/material/IconButton";
import {GoogleLogin, useGoogleLogin} from "@react-oauth/google";
import {jwtDecode} from "jwt-decode";
import Axios from "axios";
import {BACKEND_URL} from "../SignIn";
import {useNavigate} from "react-router-dom";


async function getUserInfo(codeResponse) {
    var response = await fetch("/google_login", {
        method: "POST",
        headers: {'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Method': 'GET',
        },
        body: JSON.stringify({code: codeResponse.code}),
    });
    return await response.json();
}

async function getProtected() {
    var response = await fetch("/protected", {
        method: "GET",
        credentials: "include",
        mode: "cors",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => res.json())
        .then((msg) => console.log(msg));
}

export default function Auth() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [user, setUser] = useState({});
    const navigate = useNavigate();
    const googleLogin = useGoogleLogin({
        flow: "auth-code",
        onSuccess: async (codeResponse) => {
            var loginDetails = await getUserInfo(codeResponse);
            setLoggedIn(true);
            setUser(loginDetails.user);
            localStorage.setItem("authenticated", true);
            navigate("/grow_setup");
        },
    });

    const handleLogout = () => {
        getProtected();
        setLoggedIn(false);
    };

    return (
        <>

            <IconButton
                color="primary"
                aria-label="add to shopping cart"
                onClick={() => googleLogin()}
            >
                <GoogleIcon fontSize="large"/>
            </IconButton>

        </>
    );
}
